<template>
  <v-dialog v-model="dialog" max-width="80%" persistent>
      <v-card>
            <v-card-title class="pa-1">
                <v-row class="ma-0 px-2">

                    <v-col cols="12" class="pa-0 text-right">
                        <v-btn icon color="primary" @click="close(),limpa()">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </v-col>
                    <v-col cols="12" class="pa-0 text-center">
                        <h1>Relação de Guias</h1>
                    </v-col>
                    
                    <v-col cols="6" class="col-sm-12 col-xs-12 col-lg-4 px-3">
                        <v-text-field
                        v-model="search"
                        small
                        height="30px"
                        prepend-inner-icon="mdi-magnify"
                        placeholder="Nome, Numero Carteira, Data alteração"
                        single-line
                        outlined
                        dense
                        hide-details
                        @keyup="busca(search)"
                        ></v-text-field>
                    </v-col>
                    
                </v-row>
            </v-card-title>

            

            <v-card-text class="py-0">
                <v-row>
                    <v-col cols="12" class="py-1">
                        <v-data-table dense :headers="headers" :items="primeira ? relacao : listaFiltrada" hide-default-footer :page.sync="page" :items-per-page="10" @page-count="pageCount = parseInt($event, 10)">
                            
                            <template v-slot:item.dt_alteracao="{item}">
                                {{ item.dt_alteracao | formatDate}}
                            </template>

                            <template v-slot:item.carteira_beneficiario="{item}">
                                 <span class="py-2" v-html="item.carteira_beneficiario" id="carteirinha"></span>
                            </template>

                            <template v-slot:item.nome_beneficiario="{item}">
                                 <span class="py-2" v-html="item.nome_beneficiario"></span>
                            </template>

                            <template v-slot:item.valor_total="{item}">
                               R$ {{ item.valor_total | formatPrice }}                                 
                            </template>
                            
                        </v-data-table>
                    </v-col>
                    <v-col class="pa-0" cols="12">
                        <v-pagination class="no-box-shadow" v-model="page" :length="pageCount"></v-pagination>
                    </v-col>
                </v-row>
            </v-card-text>

            <v-card-actions class="justify-center py-5">
                <v-btn
                    color="primary"
                    height="30px"
                    small
                    depressed
                    @click="close();limpa()"
                >Fechar
                </v-btn>
            </v-card-actions>
      </v-card>
  </v-dialog>
</template>

<script>
import moment from "moment"
export default {
    data() {
        return {
            
            primeira: true,
            search: null,
            listaFiltrada: null,
            
            headers: [
                { text: "Data alteração", value: "dt_alteracao", sortable: false, width: '160px' },
                { text: "Número Carteira", value: "carteira_beneficiario", sortable: false },
                { text: "Nome", value: "nome_beneficiario", sortable: false },
                { text: "valor total", value: "valor_total", sortable: false },
            ],
            page: 1,
            pageCount: 1
        }
    },
    filters: {
        formatDate(date) {
            return moment(date).format("L [às] HH:mm:ss");
        },
    },
    methods: {
        busca(texto){
            let list = Array.from(this.relacao)
            let newList = []
            //let regexData
            newList = list.reduce((arr, item) => {

                let dataConvertida = new Date(item.dt_alteracao)
                let dia = dataConvertida.getDate().toString()
                let mes = 1 + dataConvertida.getMonth()
                mes = mes.toString()
                let ano = dataConvertida.getFullYear()
                let dataString = `${dia.padStart(2, '0')}/${mes.padStart(2, '0')}/${ano}`
                
                let regex = texto ? new RegExp(texto, "gi") : null
                
                let matchSearch = regex ? item.carteira_beneficiario.match(regex) != null ||
            ( dataString && dataString.match(regex) != null ||
            item.nome_beneficiario && item.nome_beneficiario.match(regex) != null || 
            item.carteira_beneficiario && item.carteira_beneficiario.match(regex) != null ): true

            if(matchSearch) { arr.push(item) } 
            return arr
            }, [])

            this.listaFiltrada = newList
            this.primeira = false
            
        },
        limpa(){
            this.search = ''
            this.primeira = true
        }
        
    },
    props: {
        dialog: Boolean,
        close: Function,
        relacao: Array,
        
    }
}
</script>

<style>
    span#carteirinha {
        max-width: 25%;
    }
</style>
	